<template>
    <div>
        <deploy-service
            :var-obj="varObj"
            :api-param-obj="apiParamObj"
            :app-id="appId"
            :loading="loading"
            :group-arr="groupArr"
            @addGroupBySelectSuccess="getServiceGroupFn(false)"
            @changeServiceSuccess="getGroupServiceFn"
            @updateApiParamObj="updateApiParamObj"
            @resetFields="onReset"
        />
    </div>
</template>

<script>
import DeployService from '@common/views/app-resource/components/deploy-service'
import { mapActions } from 'vuex'
import * as ST from '@store/types'
import { APP_RESOURCE, STAR_MAP } from '@store/module-types'
import * as T from '@store/app-resource/types'
import _ from 'lodash'
import DataServiceMixin from '@common/views/app-resource/mixins/data-service'
import { logger } from '@mypaas/app-render-engine/core/sdk'
import { GET_MIP_API_DETAIL, GET_MIP_API_HISTORY_DETAIL } from '@store/star-map/types'
import { getObjectField } from '@api/app-resource'
import { isParamsType, fieldTransform } from './service-management'

export default {
    name: 'ServiceEditor',

    components: {
        DeployService,
    },

    mixins: [DataServiceMixin],

    data() {
        return {
            loading: {
                page: false,
                dialog: false,
                modal: false,
            },

            groupArr: [],

            apiParamObj: {
                isXingTu: false,
                type: 'custom', // custom ｜ xingTuApi | offline
            },

            apiParamObjResponseDefault: {
                codeName: 'success',
                successCodeValue: 'true',
                msgName: 'error.exception.message',
                dataName: 'result',
                totalName: 'result.total',
                dataType: '',
                isMock: false,
                mockData: '',
            },

            varObj: { requestBody: 'formData' },

            filterObj: {
                keyword: '',
                groupId: '',
                page: 1,
                pageSize: 10,
            },

            currentService: null,
        }
    },

    computed: {
        isTenantApp() {
            return this.$store.state.modeling.app.isTenant
        },

        appId() {
            return this.$route.params.appId
        },

        id() {
            return this.$route.params.id
        },

        validPurviewObject() {
            return this.$store.state.modeling.validPurview.object || {}
        },
        current() {
            return this.$store.state.WORKSPACE.current
        },
        xingtuInfo() {
            return this.current.xingtuInfo || {}
        },
    },

    async mounted() {
        await this.getServiceGroupFn()

        await this.init()
    },

    methods: {
        ...mapActions(APP_RESOURCE, {
            getServiceGroup: T.GET_NEW_SERVICE_GROUP,
            getService: T.GET_NEW_SERVICE,
            getObjectDtl: T.GET_NEW_OBJECT_DTL,
        }),
        ...mapActions(STAR_MAP, {
            getMipApiDetail: GET_MIP_API_DETAIL,
            getMipApiHistoryDetail: GET_MIP_API_HISTORY_DETAIL,
        }),
        ...mapActions({
            getValidPurview: ST.GET_VALID_PURVIEW,
        }),

        async getInfo() {
            const { manageKey = '' } = this.xingtuInfo
            const result = await this.getService({
                ids: this.id,
                manageKey,
            })

            if (result && Array.isArray(result.items)) {
                // eslint-disable-next-line prefer-destructuring
                this.currentService = result.items[0]
                return result.items[0]
            }
            return null
        },

        // 更新当前选中的服务类型
        updateServiceType(type) {
            const defaultMethod = 'get'
            const defaultParamType = 'headers'
            let  isXingTu,
                isOffline,
                paramType,
                method

            switch (type) {
                case 'offline':
                    isXingTu = false
                    isOffline = true
                    paramType = 'request'
                    method = 'local'
                    break
                case 'xingTuApi':
                    isXingTu = true
                    isOffline = false
                    break
                default:
                    isXingTu = false
                    isOffline = false
                    break
            }
            this.apiParamObj.isXingTu = isXingTu
            this.apiParamObj.isOffline = isOffline
            this.apiParamObj.method = method || defaultMethod
            this.varObj.paramType = paramType || defaultParamType
            this.apiParamObj.domainVariableKey = isXingTu ? 'sys_mip_env' : 'sys_default_domain'
        },

        async init() {
            if (this.isTenantApp) {
                this.loading.modal = true
                await this.getValidPurview({ appId: this.appId })
                this.loading.modal = false
            }

            let groupId = this.$route.query.group
            if (!groupId || !this.groupArr.find(d => d.id === groupId)) {
                groupId = (this.groupArr.find(group => group.isSystem) || {}).id
            }

            let { type } = this.$route.params
            if (type && type.toLowerCase() === 'xingTuApi'.toLowerCase()) {
                type = 'xingTuApi'
            } else if (type !== 'offline' && type !== 'custom') {
                type = 'custom'
            }

            let paramType = 'headers'
            this.apiParamObj = {
                groupId,
                method: 'get',
                api: '',
                type: type || 'custom',
                isXingTu: type === 'xingTuApi',
                isOffline: type === 'offline',
                response: { ...this.apiParamObjResponseDefault },
                querys: [],
                body: {},
                headers: [],
                remark: '',
                domainVariableKey: 'sys_default_domain',
            }

            if (this.isTenantApp) {
                this.apiParamObj.isTenant = true
            }

            this.updateServiceType(type)

            if (this.id) {
                const item = await this.getInfo()
                if (item) {
                    if (item.isXingTu && item.xingTuApiId) {
                        await this.editStarMap(type, item)
                        return
                    }
                    // 编辑自定义服务
                    this.$set(this.varObj, 'serviceId', item.id)
                    const requestBody = (item.body || { type: 'params' }).type
                    const requestType = requestBody === 'object' ? 'postData' : 'formData'
                    this.$set(this.varObj, 'requestBody', requestType);
                    (item.response || {}).successCodeValue = String(item.response.successCodeValue)

                    if (this.isTenantApp) {
                        const {
                            isTenant, customizeType, customizeField,
                        } = item
                        this.apiParamObj.isTenant =  isTenant
                        this.apiParamObj.customizeType = customizeType
                        this.apiParamObj.customizeField = customizeField
                    }
                    this.apiParamObj = {
                        ...this.apiParamObj,
                        groupId: item.groupId || groupId,
                        name: item.name,
                        url: item.url,
                        method: item.method,
                        type: this.getServiceType(item),
                        title: item.title,
                        isXingTu: item.isXingTu,
                        isOffline: item.isOffline,
                        remark: item.remark || '',
                        // response: { ...(item.response || {}), isMock: !!item.isMock, mockData: item.isMock ? JSON.stringify(item.mockData) : item.mockData },
                        response: { ...(item.response || {}), isMock: !!item.isMock, mockData: item.mockData },
                        querys: this.replaceAppend(item.querys || []),
                        body: {
                            ...item.body,
                            params: this.replaceAppend(item.body.params || []),
                        } || {
                            object: {
                                objectId: '',
                            },
                        },
                        headers: this.replaceAppend(item.headers || []),
                        domainVariableKey: item.domainVariableKey || this.getDefaultDomainVariableKey(item.url, item.isXingTu),
                    }
                    if (this.isTenantApp) {
                        const {
                            name,
                            isTenant,
                        } = item
                        const reg = new RegExp(`${item.customizeField}$`)
                        this.apiParamObj.name =  name.replace(reg, '')
                        this.apiParamObj.isTenant =  isTenant
                    }
                    paramType = item.isOffline ? 'request' : paramType
                }
            }

            paramType = this.apiParamObj.isOffline ? 'request' : paramType

            this.$set(this.varObj, 'optBool', true)
            this.$set(this.varObj, 'optType', this.id && this.currentService ? '编辑' : '添加')
            this.$set(this.varObj, 'paramType', paramType)
        },

        getDefaultDomainVariableKey(url, isXingTu) {
            const defaultKey = isXingTu ? 'sys_mip_env' : 'sys_default_domain'
            if (url && /https?:\/\//.test(url)) {
                return ''
            }
            return defaultKey
        },

        replaceAppend(arr) {
            if (this.isTenantApp) {
                return arr.map(item => {
                    let reg = ''
                    if (item.addField) {
                        if (item.customizeType === 0) {
                            reg = new RegExp(`^${item.customizeField}`)
                        } else {
                            reg = new RegExp(`${item.customizeField}$`)
                        }
                        item.key = item.key.replace(reg, '')

                        if (this.isTenantApp && !this.apiParamObj.isTenant) {
                            item.customizeType =  this.validPurviewObject.customizeType
                            item.customizeField = this.validPurviewObject.customizeField
                        }
                    }
                    return item
                })
            }
            return arr
        },

        // 获取服务类型名称
        getServiceType(serviceItem) {
            return serviceItem.isXingTu ? 'xingTuApi' : serviceItem.isOffline ? 'offlineService' : 'customCreate'
        },

        async editStarMap(type, item) {
            try {
                this.editLoadingId = item.id
                const { manageKey = '' } = this.xingtuInfo
                const mipApiDetail = await this.getMipApiHistoryDetail({
                    id: this.id,
                    manageKey,
                })
                const data = {
                    headers: mipApiDetail.headers,
                    groupId: item.groupId || this.filterObj.groupId,
                    name: item.name,
                    url: item.url,
                    api: item.xingTuApiId,
                    method: item.method,
                    title: item.title,
                    isXingTu: item.isXingTu,
                    type: this.getServiceType(item),
                    hasAuth: !!mipApiDetail.hasAuth,
                    remark: item.remark || '',
                    response: item.response || {},
                    querys: mipApiDetail.querys || [],
                    paths: mipApiDetail.paths,
                    authType: mipApiDetail.authType,
                }
                data.response.successCodeValue = String(data.response.successCodeValue)
                if (['object', 'objectArray'].includes(data.response.dataType)) {
                    data.response.schema = {
                        name: 'root',
                        title: 'root',
                        type: 'object',
                        id: this.guid(),
                        fields: this.addIdToArr(mipApiDetail.responseMetadata.fields),
                    }
                }
                if (data.method === 'get') {
                    data.body = item.body || {}
                } else {
                    data.body = {
                        params: this.formatBody(mipApiDetail.requestMetadata, item.body),
                        contentType: mipApiDetail.requestMetadata.dataType,
                        type: isParamsType(mipApiDetail.requestMetadata.dataType) ? 'params' : 'object',
                    }
                }
                this.apiParamObj = data
                this.$set(this.varObj, 'serviceId', item.id)
                this.$set(this.varObj, 'optType', type)
                this.$set(this.varObj, 'paramType', 'headers')
                this.$nextTick(() => {
                    this.$set(this.varObj, 'optBool', true)
                })
            } catch (err) {
                logger.log(err)
            }
        },

        addIdToArr(arr) {
            if (!Array.isArray(arr)) return []
            return arr.map(item => {
                let { fields } = item
                if (Array.isArray(fields)) {
                    fields = this.addIdToArr(fields)
                }
                return {
                    ...item,
                    id: this.guid(),
                    fields,
                }
            })
        },

        guid() {
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
                const r = Math.random() * 16 | 0
                // eslint-disable-next-line no-mixed-operators
                const v = c === 'x' ? r : (r & 0x3 | 0x8)
                return v.toString(16)
            })
        },

        formatBody(requestMetadata, body) {
            function formatObjectItem(schema) {
                return schema.map(item => {
                    const result = {
                        id: item.id,
                        name: item.name,
                        type: item.type,
                        title: item.name,
                        remark: item.remark,
                        handle: item.handle || '',
                        disable: !item.isRoot,
                        required: !!item.required,
                        relevanceMsg: {
                            isMatching: false,
                            name: '',
                            title: '',
                        },
                    }
                    if (item.objectId) {
                        result.objectId = item.objectId
                    }
                    if (Array.isArray(item.fields) && item.fields.length) {
                        result.fields = formatObjectItem(item.fields)
                    }
                    return result
                })
            }
            const formatParamsFields = fieldsArr => fieldsArr.map(item => {
                const { params } = body
                const index = params.findIndex(i => item.name === i.key)
                const result = {
                    id: item.id,
                    name: item.name,
                    type: item.type,
                    title: item.name,
                    remark: item.remark,
                    required: !!item.required,
                    handle: index === -1 ? 'noHandle' : 'params',
                    disable: false,
                    relevanceMsg: {
                        isMatching: false,
                        name: '',
                        title: '',
                    },
                }
                if (Array.isArray(item.fields) && item.fields.length) {
                    result.fields = formatObjectItem(item.fields)
                }
                if (['object', 'objectArray'].includes(result.type) && index !== -1) {
                    result.objectId = params[index].objectId
                    this.getObjectField(result)
                    this.getObjectDtlFn(result, result.objectId)
                }
                return result
            })
            const dataType = requestMetadata?.dataType
            if (isParamsType(dataType)) {
                return Array.isArray(requestMetadata.fields) ? requestMetadata.fields.map(item => {
                    const data = fieldTransform(item)
                    const { params } = body
                    if (Array.isArray(params) && params.find(d => d.key === (data.name || data.key))) {
                        data.handle = 'pair'
                    } else {
                        data.handle = ''
                    }
                    return data
                }) : []
            }
            if (body.type === 'object') {
                requestMetadata = [{
                    ...requestMetadata,
                    title: 'root',
                    name: 'postData',
                    type: 'object',
                    handle: 'params',
                    isRoot: true,
                    objectId: body.object.objectId,
                }]
                requestMetadata = formatObjectItem(this.addIdToArr(requestMetadata))
                const root = requestMetadata[0]
                this.getObjectField(root)
                this.getObjectDtlFn(root, root.objectId)
                return requestMetadata
            }
            const fields = formatParamsFields(this.addIdToArr(requestMetadata.fields))
            return [{
                fields,
                id: this.guid(),
                title: 'root',
                name: 'root',
                type: 'object',
                handle: 'noHandle',
                isRoot: true,
            }]
        },

        getObjectField(row) {
            getObjectField({
                objectId: row.objectId,
            }).then(data => {
                const fields = row.items || []
                fields.forEach(item => {
                    item.handle = 'matching'
                    const index = data.findIndex(i => i.type === item.type && i.name === item.name)
                    if (index === -1) {
                        this.changeFieldsHandle(item, 'matching')
                        return
                    }
                    item.relevanceMsg = {
                        isMatching: true,
                        name: data[index].name,
                        title: data[index].title,
                    }
                    if (item.type === 'object' || item.type === 'objectArray') {
                        this.getObjectField({
                            objectId: data[index]?.relatedObject?.id,
                        })
                    }
                })
            })
        },

        async getObjectDtlFn(obj, id) {
            if (!id) {
                return
            }
            try {
                const resData = await this.getObjectDtl({
                    objectId: id,
                })
                this.$set(obj, 'objectName', resData.title)
                // eslint-disable-next-line no-empty
            } catch (error) {}
        },

        async getServiceGroupFn(loading = true) {
            try {
                this.loading.page = loading
                this.groupArr = await this.getServiceGroup()
                this.loading.page = false
            } catch (error) {
                this.loading.page = false
            }
        },

        onReset() {
            if (this.apiParamObj.body && this.apiParamObj.body.object) {
                this.apiParamObj.body.object.objectId = ''
            }
            if (this.apiParamObj.body.params) {
                this.apiParamObj.body.params = []
            }
            this.apiParamObj.method =  this.apiParamObj.type === 'offlineService' ? 'local' : 'get'
            this.apiParamObj.response.objectId = ''
        },

        updateApiParamObj(e = {}) {
            const {
                isNotXingTuApi, data, replace = false, isOffline = false,
            } = e
            if (replace) {
                this.apiParamObj = _.cloneDeep(data)
                return
            }
            if (!data) {
                let paramType = 'headers'
                this.apiParamObj = {
                    ...this.apiParamObj,
                    api: '',
                    name: '',
                    title: '',
                    remark: '',
                    url: '',
                    response: { ...this.apiParamObjResponseDefault },
                    querys: [],
                    body: {},
                    headers: [],
                    paths: [],
                }
                if (isOffline) {
                    this.apiParamObj.body = { object: {}, type: 'params', params: [] }
                    paramType = isOffline ? 'request' : paramType
                }
                this.$set(this.varObj, 'paramType', paramType)
                return
            }
            if (!isNotXingTuApi) {
                let body = {}
                if (data && data.body && data.body.type === 'object') {
                    body = data.body.object || { objectId: '' }
                }
                this.apiParamObj = {
                    ...this.apiParamObj,
                    title: data.title,
                    name: data.name,
                    url: data.url,
                    remark: data.remark,
                    method: data.method,
                    hasAuth: data.hasAuth,
                    querys: data.querys || [],
                    body: {
                        params: data.requestMetadata,
                        type: data?.body?.type || 'params',
                        object: {
                            ...body,
                        },
                        contentType: data.requestMetadata[0]?.contentType || data?.body?.contentType,
                    },
                    response: { ...this.apiParamObjResponseDefault, ...data.responseMetadata || {} },
                    headers: data.headers || [],
                    paths: data.paths,
                    version: data.version,
                    authType: data.authType,
                }
            }
        },

        // 查询分组中的服务列表
        async getGroupServiceFn() {
            const { manageKey = '' } = this.xingtuInfo
            if (!this.loading.page && !this.varObj.optBool) {
                this.$set(this.loading, 'table', true)
            }

            try {
                const resData = await this.getService({
                    ...this.filterObj,
                    xingTuEnvId: this.xingTuEnvId,
                    manageKey,
                })
                this.serviceArr = resData.items || []
                this.defaultServiceArr = _.cloneDeep(resData.items) || []
                this.$set(this.filterObj, 'total', resData.total)
                this.loading.table = false
                this.updateDesignerDataServiceList()
            } catch (error) {
                this.loading.table = false
            }
        },
    },
}
</script>
